// French for the client page (the standing brief). Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  'That client does not exist (anymore).': 'Ce client n’existe pas (plus).',
  'This task carries no route — open it on the engagement it belongs to.': 'Cette tâche ne porte aucune route — ouvrez-la dans le mandat auquel elle appartient.',
  '← Clients': '← Clients',
  'The full timeline': 'La chronologie complète',
  'The library': 'La bibliothèque',
  'The client record': 'Le dossier client',
  '← Back to the brief': '← Retour au briefing',
  'active': 'actif',
  'dormant': 'dormant',
  'archived': 'archivé',
  'nothing on the client record yet': 'rien au dossier client pour l’instant',
  'Record': 'Dossier',
  'New engagement': 'Nouveau mandat',
  'Legal name': 'Raison sociale',
  'Short name': 'Nom court',
  'Sector': 'Secteur',
  'Address': 'Adresse',
  'First contact': 'Premier contact',
  'no dated evidence': 'aucune preuve datée',
  'On the record since': 'Au dossier depuis',
  'Sponsor': 'Sponsor',
  'nobody named': 'non désigné',
  'Open the record →': 'Ouvrir le dossier →',
  '{code} created — open it from the switcher or the Lifecycle page': '{code} créé — ouvrez-le depuis le sélecteur ou la page Cycle de vie',
}, 'ClientPage');
